import { formatDate, IconChangeLoClock, IconClock } from '@ui/src';
import Card from '../../card/card';
import { AMLGeneralInfoWrapperTypes } from '../types';

import cn from '../styles.module.css';

const AmlGeneralInfoWrapper = ({
  isLoading,
  children,
  nextReviewDate,
  title,
  auditLogAllowed,
  setChangeLogPanelIsOpen,
}: AMLGeneralInfoWrapperTypes): React.JSX.Element => (
  <div className={cn.amlGeneralInfoContent}>
    <div className={cn.amlGeneralInfoContentTop}>
      <div className={cn.amlGeneralInfoContentTitle}>General Information</div>
      <div className={cn.amlGeneralInfoContentTopRight}>
        {auditLogAllowed && setChangeLogPanelIsOpen && (
          <button
            type="button"
            className={cn.applicationLink}
            onClick={() => setChangeLogPanelIsOpen(true)}
          >
            <IconChangeLoClock />
            Change Log
          </button>
        )}
        {!isLoading && (
          <div className={cn.amlGeneralInfoNextReview}>
            <IconClock className={cn.amlGeneralClockIcon} />
            Next review
            <div className={cn.amlGeneralInfoNextReviewDate}>
              {formatDate(nextReviewDate as string)}
            </div>
          </div>
        )}
      </div>
    </div>
    {title && children && (
      <Card isLoading={isLoading}>
        <div className={cn.amlGeneralInfoCardContent}>
          {title && <div className={cn.amlGeneralInfoCardTitle}>{title}</div>}
          {children}
        </div>
      </Card>
    )}
  </div>
);

export default AmlGeneralInfoWrapper;
